<template>
  <div>
    <v-header :seller="seller">
      v-header
    </v-header>
    <div class="tab border-1px">
      <div class="tab-item">
       <a v-link="{path:'/goods'}" href="">商品</a>
      </div>

      <div class="tab-item">
        <a v-link="{path:'/ratings'}" href="">评论</a>
      </div>
      <div class="tab-item">
        <a v-link="{path:'/seller'}" href="">商家</a>
      </div>
    </div>
    <router-view :seller="seller"></router-view>
  </div>
</template>
<script type="text/ecmascript-6">
  import header from './components/header/header.vue';
  const ERR_OK = 0;
  export default {
    data() {
      return {
        seller: {

        }
      };
    },
    created() {
      this.$http.get('static/data.json').then((response) => {
        response = response.body;
        if (response.errno !== ERR_OK) {
          this.seller = response.seller;
        }
      });
    },
    components: {
        'v-header': header
    }
  };
</script>
<style lang="stylus" rel="stylesheet/stylus">
  @import "./common/stylus/mixin.styl";
  .tab
    display: flex
    width: 100%
    height: 40px
    line-height: 40px
    border-1px(rgba(7, 17, 27, 0.1))
    .tab-item
      flex: 1
      text-align center
      & > a
        display: block
        font-size 14px
        height: 40px
        color: rbg(77, 85, 93)
        &.active
          color: rgb(240, 20, 20)
</style>



// WEBPACK FOOTER //
// App.vue?7259413a